import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFAB } from "./WhatsAppFAB";
import { TopBar } from "./TopBar";

export function Layout() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="site-root">
      <TopBar />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
